import {createContext} from "@lit/context";
import type {MembershipDataContextValue} from "./MembershipData";

export const MembershipDataContext = createContext<MembershipDataContextValue>(
  "membership-data-context"
);
